import {FEATURE_NAMES} from "@/src/modules/routing/utils/constants";

const FEATURE_ERROR_TITLES: Record<string, string> = {
  "shifts:break_before_scheduled_time": "Break cannot be started before its scheduled time",
  "shifts:break_extends_past_shift_end": "Break cannot extend past shift end",
  "shifts:no_active_break": "No active break on server",
  "shifts:gps_permission_denied": "Shifts: GPS blocked",
  "shifts:gps_timeout": "Shifts: GPS timed out",
  "shifts:gps_unavailable": "Shifts: GPS unavailable",
  "shifts:location_required": "Shifts: Location rejected at shift start",
  "shifts:shift_start_failed": "Shifts: Shift start failed",
  "shifts:shift_end_failed": "Shifts: Shift end failed",
  "shifts:break_action_failed": "Shifts: Break action failed",
  "dars:network_aborted": "DARs: request failed (network)",
  "dars:network_offline": "DARs: network unavailable",
  "dars:http_500": "DARs: server error",
  "dars:gps_permission_denied": "DARs: GPS blocked",
  "dars:gps_timeout": "DARs: GPS timed out",
  "dars:gps_unavailable": "DARs: GPS unavailable",
  "dars:location_required": "DARs: Location required by server",
  "dars:camera_permission_denied": "DARs: Camera blocked",
  "dars:file_pick_failed": "DARs: File selection failed",
  "dars:image_compress_failed": "DARs: Photo processing failed",
  "dars:media_upload_failed": "DARs: Upload failed",
  "incidents:server_error": "Incidents: server error",
  "incidents:http_500": "Incidents: server error",
  "incidents:gps_permission_denied": "Incidents: GPS blocked",
  "incidents:camera_permission_denied": "Incidents: Camera blocked",
  "incidents:media_upload_failed": "Incidents: Upload failed",
  "citations:gps_permission_denied": "Citations: GPS blocked",
  "citations:camera_permission_denied": "Citations: Camera blocked",
  "citations:media_upload_failed": "Citations: Upload failed",
  "dispatchlogs:network_aborted": "Dispatch Logs: request failed (network)",
  "dispatchlogs:http_500": "Dispatch Logs: server error",
  "vehicles:validation_failed": "Vehicle validation failed",
  "citations:validation_failed": "Citation validation failed",
  "safelistings:validation_failed": "Safelisting validation failed",
  "storedvehicles:validation_failed": "Stored vehicle validation failed",
  "platform:react_render_error": "Application render error",
  "platform:unhandled_rejection": "Unhandled error",
  "platform:network_aborted": "Network request aborted",
  "platform:network_offline": "Network unavailable",
  "platform:http_500": "Platform: server error",
  "platform:realtime_connection_failed": "Platform: live updates connection failed",
  "platform:broadcasting_auth_failed": "Platform: live updates auth failed",
  "platform:push_permission_denied": "Platform: Push alerts blocked",
  "platform:push_subscription_failed": "Platform: Push subscription failed",
  "platform:gps_permission_denied": "GPS blocked",
  "platform:location_required": "Location required by server",
  "platform:connection_lost": "Platform: connection lost",
  "platform:reference_error": "Application reference error",
  "platform:service_worker_load_failed": "Platform: service worker failed to load",
  "platform:realtime_auth_timeout": "Platform: live updates auth timed out",
  "platform:unhandled_promise_rejection": "Unhandled promise rejection",
  "platform:camera_unavailable": "Platform: Camera unavailable",
  "platform:camera_capture_failed": "Platform: In-app photo capture failed",
  "platform:camera_flash_torch_failed": "Platform: Camera flash torch failed",
  "platform:file_pick_cancelled": "Platform: Gallery pick cancelled",
  "platform:pwa_killed_during_file_picker": "Platform: App restarted during gallery pick",
};

const TELEMETRY_EVENT_TITLES: Record<string, string> = {
  "poolaccesslogs:client_validation_failure": "Pool Access Logs: validation failed before submit",
  "dars:client_validation_failure": "DARs: validation failed before submit",
  "incidents:client_validation_failure": "Incidents: validation failed before submit",
  "dispatchlogs:client_validation_failure": "Dispatch Logs: validation failed before submit",
  "companyvehicles:client_validation_failure": "Company vehicles: validation failed before submit",
  "dars:gps_fallback_used": "DARs: GPS fallback used",
  "incidents:gps_fallback_used": "Incidents: GPS fallback used",
  "shifts:gps_fallback_used": "Shifts: GPS fallback used",
  "platform:glitchtip_client_boot": "Platform: GlitchTip client boot (dev build)",
  "platform:photo_attached": "Platform: Photo attached",
  "platform:camera_flash_probed": "Platform: Camera flash capability probed",
  "platform:camera_flash_toggled": "Platform: Camera flash toggled",
};

function humanizeErrorCode(code: string): string {
  return code.replace(/_/g, " ");
}

export function getEventTitle(feature: string, errorCode: string): string {
  return (
    FEATURE_ERROR_TITLES[`${feature}:${errorCode}`] ??
    `${FEATURE_NAMES[feature as keyof typeof FEATURE_NAMES] ?? feature}: ${humanizeErrorCode(errorCode)}`
  );
}

export function getTelemetryTitle(feature: string, eventType: string): string {
  return (
    TELEMETRY_EVENT_TITLES[`${feature}:${eventType}`] ??
    `${FEATURE_NAMES[feature as keyof typeof FEATURE_NAMES] ?? feature}: ${humanizeErrorCode(eventType)}`
  );
}
